import React, { Component } from 'react';
import without from 'lodash/without';
import union from 'lodash/union';
import partial from 'lodash/partial';
import classnames from 'classnames';
import isEmail from 'sane-email-validation';

export default class FriendsField extends Component {
  constructor(props) {
    super(props);

    this.state = { email: '', invalid: false };

    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
  }

  changeEmail(e) {
    const email = e.target.value;
    const invalid = !isEmail(email);
    this.setState({ email, invalid });
  }

  add() {
    const { input } = this.props;
    const { email } = this.state;
    const value = input.value || [];

    if (!isEmail(email)) {
      this.setState({ invalid: true });
      return;
    }

    input.onChange(union(value, [email]));

    this.setState({ email: '', invalid: false });
  }

  remove(email) {
    const { input } = this.props;
    const value = input.value || [];
    input.onChange(without(value, email));
  }

  render() {
    const { input, meta } = this.props;
    const { email, invalid } = this.state;
    const value = input.value || [];
    const hasError = meta.touched && meta.invalid;

    const groupClasses = classnames('form-group', { error: invalid });
    const controlClasses = classnames('form-control', { filled: email });

    return (
      <div className="friends-field">
        <div className="row">
          <div className="columns small-16 medium-11">
            <div className={groupClasses}>
              <input onChange={this.changeEmail} value={email} type="email" name="email"
                className={controlClasses} />
              <span className="bar" />
              <label htmlFor="email" className="form-label animate">
                Enter your friend's email address...
              </label>
              { invalid && <span className="error-msg">Please enter a valid email</span> }
            </div>
          </div>
          <div className="columns small-16 medium-5">
            <button type="button" className="btn btn-md btn-tertiary" onClick={this.add}>
              Add email
            </button>
          </div>
        </div>
        { value.map((email, i) => (
          <div key={i} className="friend-row">
            { email }
            <i onClick={partial(this.remove, email)} className="fa fa-times-circle pull-right" />
          </div>
        )) }
        { hasError && <div className="callout alert">{ meta.error }</div> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./marketing/components/friends_field.jsx